<template>
    <custom-dialog width="1136px" :showClose="true" title="打印预览" v-if="visibleObj.executePrintDialog"
        :visible="visibleObj.executePrintDialog" @close="dialogVisible('executePrintDialog')" saveBtnTitle="打印" @save="handlePrint">
        <div slot="content" class="executePrint-warp">
            <!-- <div class="executePrint-title">成都青羊杏林明德中医诊所</div> -->
            <div class="info-warp">
                <div>姓名：{{ patientInfo .patientName}} {{ patientInfo.sex == '0' ? '男' : '女' }} {{ patientInfo.age }}岁</div>
                <div>手机：{{ patientInfo.phone }}</div>
                <div>日期：{{ getCurrentDate }}</div>
            </div>
            <div class="mt8">
                <customTable border :tableData="executeList" :showPages="false" :column="column">
                </customTable>
            </div>
        </div>
    </custom-dialog>
</template>
  
<script>
import CustomDialog from '@/components/customDialog/CustomDialog'
import customTable from '@/components/customTable/customTable'
import { Utils } from '@/utils/utils'
export default {
    // 定义引入的组件
    components: { CustomDialog, customTable },
    props: {
        visibleObj: {
            type: Object,
            default: () => { return {} }
        },
        dialogObj: {
            type: Object,
            default: () => { return {} }
        },
    },
    data() {
        return {
            executeList: [],
            column: [
                { label: '理论项目', prop: 'physioName' },
                { label: '诊断', prop: 'diagnosis' },
                { label: '治疗部位', prop: 'physioPosition' },
                { label: '治疗穴位', prop: 'acupoint' },
                { label: '次数', prop: 'executeNum' },
                { label: '医生签名', prop: 'doctorName' },
                { label: '患者签名', prop: 'patient' },
            ],
            patientInfo:{},
        }
    },
    //变量监听
    watch: {},
    computed:{
        getCurrentDate(){
            return Utils.timeFormat(this.$moment().startOf('day'),'yyyy-MM-DD')
        }
    },
    // 页面初始化
    created() {
        let { patientInfo, executeList } = this.dialogObj.executePrintObj
        this.patientInfo= patientInfo
        this.executeList = executeList
    },
    // 页面DOM加载完成
    mounted() { },
    //离开页面时执行
    destroyed() { },
    // 页面方法
    methods: {
        /**
        * 关闭
        */
        dialogVisible(name) {
            this.$emit("close", name);
        },
        /**
         * 打印
         */
        handlePrint(){
           this.$emit('updateData')
        }
    },
}
</script>
<style lang="less" scoped>
/deep/.dialog-content {
    background: #D9D9D9;
    padding: 16px !important;
}

.executePrint-warp {
    color: #1F2329;
    padding: 24px;
    background: #fff;

    .executePrint-title {
        text-align: center;
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 16px;
    }

    .info-warp {
        display: flex;
        justify-content: space-between;
        font-size: 14px;
    }

}
</style>